import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormField } from '../models/form.model';
import { FormValidationService } from '../service/form-validation.service';

@Component({
  selector: 'app-form-select-one-field',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="form-group">
      <label [for]="field.id" class="form-label">
        {{ field.label }}
        <span *ngIf="field.required" class="required">*</span>
      </label>
      <div *ngIf="field.helpText" class="help-text">{{ field.helpText }}</div>
      <select
        [id]="field.id"
        class="form-control"
        (change)="onSelect($event)"
        [class.is-invalid]="hasError"
      >
        <option value="" [selected]="!value">-- Select --</option>
        <option *ngFor="let opt of field.options" [value]="opt.value" [selected]="value === opt.value">{{ opt.label }}</option>
      </select>
      <div *ngIf="hasError && error" class="invalid-feedback">
        {{ validationService.getErrorMessage(field, error) }}
      </div>
    </div>
  `,
  styles: [`
    .form-group { margin-bottom: 1rem; }
    .form-label { font-weight: 500; display: block; margin-bottom: 0.5rem; }
    .required { color: red; }
    .help-text { font-size: 0.875rem; color: #6c757d; margin-bottom: 0.25rem; }
    .form-control { width: 100%; padding: 0.5rem; border: 1px solid #ced4da; border-radius: 0.25rem; }
    .form-control.is-invalid { border-color: #dc3545; }
    .invalid-feedback { color: #dc3545; font-size: 0.875rem; margin-top: 0.25rem; }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormSelectOneFieldComponent implements OnInit, OnChanges {
  @Input() field!: FormField;
  @Input() value: string | undefined;
  @Output() valueChange = new EventEmitter<string>();
  @Output() errorChange = new EventEmitter<any>();

  error: any = null;
  hasError = false;

  constructor(public validationService: FormValidationService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.validateField();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value'] && !changes['value'].firstChange) {
      this.validateField();
      this.cdr.markForCheck();
    }
  }

  onSelect(event: Event): void {
    const target = event.target as HTMLSelectElement;
    this.value = target.value;
    this.valueChange.emit(this.value);
    this.validateField();
  }

  getSelectedValue(): string {
    return this.value || '';
  }

  private validateField(): void {
    this.error = this.validationService.validateField(this.field, this.value);
    this.hasError = !!this.error;
    this.errorChange.emit(this.error);
  }
}
